import { render, staticRenderFns } from "./LogoTextDark.vue?vue&type=template&id=061dbeb2&scoped=true&"
var script = {}
import style0 from "./LogoTextDark.vue?vue&type=style&index=0&id=061dbeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061dbeb2",
  null
  
)

export default component.exports